import type { ComputedRef } from 'vue';

export interface MenuItem {
  type: 'button' | 'link';
  icon: string;
  text: string | ComputedRef<string>;
  onClick?: () => void;
  to?: string;
  activeCondition?: boolean | ComputedRef<boolean>;
  visibleCondition?: boolean | ComputedRef<boolean>;
  hasBadge?: boolean;
}

export const useMobileMenu = () => {
  const { t: $t } = useTexts();
  const layoutStore = useLayoutStore();
  const { isMenuAnimating } = storeToRefs(layoutStore);
  const { isSportsHomePage } = useSportsBook();
  const { isCasinoCategoryPageActive } = useCasino();
  const { openLogin } = useAuth();
  const route = useRoute();

  const showCasinoSubMenu = ref(false);

  const handleMenuItemClick = (callback?: () => void) => {
    layoutStore.closeMenu();
    showCasinoSubMenu.value = false;
    callback?.();
  };

  const mainMenuButtons = computed<MenuItem[]>(() => [
    // index 0 — Esporte
    {
      type: 'link',
      icon: 'mobile-menu-bar/esporte',
      text: 'Esporte',
      to: '/sports',
      onClick: () => handleMenuItemClick(),
      activeCondition: isSportsHomePage.value,
    },
    // index 1 — Ao vivo
    {
      type: 'link',
      icon: 'mobile-menu-bar/ao-vivo',
      text: 'Ao vivo',
      to: '/games/category/all?initialCategory=jogos-ao-vivo',
      onClick: () => handleMenuItemClick(),
      activeCondition:
        isCasinoCategoryPageActive('all') &&
        route.query.initialCategory === 'jogos-ao-vivo',
    },
    // index 2 — Home badge placeholder (rendered as <HomeBadge> when authenticated, login button otherwise)
    {
      type: 'button',
      icon: 'mobile-menu-bar/entrar',
      text: 'Entrar',
      onClick: () => {
        layoutStore.setAuthInitialTab('login');
        handleMenuItemClick(openLogin);
      },
    },
    // index 3 — Slots
    {
      type: 'link',
      icon: 'mobile-menu-bar/slots',
      text: 'Slots',
      to: '/games/category/all?initialCategory=mais-apostados',
      onClick: () => handleMenuItemClick(),
      activeCondition:
        isCasinoCategoryPageActive('all') &&
        (route.query.initialCategory === 'mais-apostados' ||
          route.query.initialCategory === 'mais-pagos'),
    },
    // index 4 — Menu
    {
      type: 'button',
      icon: layoutStore.menuOpen
        ? 'mobile-menu-bar/close'
        : 'mobile-menu-bar/menu',
      text: $t('menu_mobile.menu'),
      onClick: () => {
        layoutStore.toggleMenuOpen();
        showCasinoSubMenu.value = false;
      },
    },
  ]);

  return {
    showCasinoSubMenu,
    mainMenuButtons,
    isMenuAnimating,
  };
};
